__turbopack_context__.v({
  "list": "Tabs-module__AnwDuq__list",
  "listScrollable": "Tabs-module__AnwDuq__listScrollable",
  "root": "Tabs-module__AnwDuq__root",
  "tab": "Tabs-module__AnwDuq__tab",
  "tabScrollable": "Tabs-module__AnwDuq__tabScrollable",
});
